import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { Cell } from '..';
import { CellTooltip } from '../../..';
import type { PrizeTableTooltip, TableRowProps } from '../../../../../../types';

type ClassMap = {
  [key: number]: string;
};

type RowProps = ComponentProps<'tr'> & {
  headers: TableRowProps['headers'];
  rowIndex: number;
  data?: TableRowProps['row'];
  alignment?: ClassMap;
  columnsWidth?: ClassMap;
  tooltips?: PrizeTableTooltip;
};

const columnAlignment: ClassMap = {
  0: 'justify-start',
  1: 'justify-start',
  2: 'justify-end text-right',
  3: 'justify-end text-right',
};

const columsPattern: ClassMap = {
  3: 'grid-cols-[10%_35%_1fr]',
  4: 'grid-cols-[10%_35%_repeat(2,1fr)]',
};

function Row({ className, headers, rowIndex, data, alignment = columnAlignment, columnsWidth = columsPattern, tooltips, ...props }: RowProps) {
  const isHeaderRow = !data;
  const classes = {
    row: twMerge('px-4 grid', columnsWidth[headers.length], rowIndex % 2 === 0 ? 'bg-container-base' : 'bg-container', isHeaderRow ? 'border-b border-border' : '', className),
    cell: (index: number) => twMerge('my-auto w-full flex gap-2 items-center', isHeaderRow ? 'paragraph-explanatory' : 'paragraph-explanatory-strong', alignment[index]),
  };
  return (
    <tr className={classes.row} {...props}>
      {headers.map(({ value, label }, index) => (
        <Cell key={value} className={classes.cell(index)} data-testid={isHeaderRow ? undefined : `prize-table-desktop-row-${rowIndex}-${value}`}>
          {isHeaderRow ? label : data[value as keyof TableRowProps['row']]}
          {tooltips && tooltips.get(value) ? <CellTooltip>{tooltips.get(value)}</CellTooltip> : null}
        </Cell>
      ))}
    </tr>
  );
}

export { Row };
export type { RowProps };
